import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

const Container = styled.div`
  padding: 16px;
  background-color: #f7f7f7;
  border: 1px solid #d1d1d6;
`;
const NonStandardText = styled.p`
  color: #303641;
  font-weight: 600;
  border-bottom: 1px solid #d1d1d6;
  padding-bottom: 5px;
`;
const NonRiskContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 500px);
  gap: 15px;
  padding-left: 23px;
`;

export default ({ selectedNonStandardRisk }: { selectedNonStandardRisk?: string[] }) => {
  return (
    <>
      {selectedNonStandardRisk && (
        <Container>
          <NonStandardText>NON-STANDARD RISK TERMS</NonStandardText>
          <NonRiskContainer>
            {selectedNonStandardRisk.map((nsr: string) => (
              <div key={uuid()}>{nsr}</div>
            ))}
          </NonRiskContainer>
        </Container>
      )}
    </>
  );
};
